import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const PriceStruct = ({ prcStrctData: initPrcStrctData, onUpdate }) => {
  const [prcStrctData, setPrcStrctData] = useState(initPrcStrctData);

  useEffect(() => {

  }, [prcStrctData]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    const currPrcStruct = { ...prcStrctData, [name]: value };
    setPrcStrctData(currPrcStruct);
    onUpdate(prcStrctData.psId, getDataFieldName(name), value);
  };

  const handleClearPriceStruct = () => {
    const currPrcStruct = {
      ...prcStrctData,
      status: 'remove',
    };
    setPrcStrctData(currPrcStruct);
    onUpdate(prcStrctData.psId, 'status', 'remove', {});
  };

  const getDataFieldName = (name) => {
    switch (name) {
      case 'name':
        return 'prcStrctTx';
      case 'selfHelpAmt':
        return 'feeAm';
      case 'volFeeAmt':
        return 'vlntrFeeAm';
      case 'dealerVolFeeAmt':
        return 'vlntrTodlrFeeAm';
      case 'closeFeeAmt':
        return 'clsFeeAm';
      default:
        return name;
    }
  };
  const handleSelection = (e) => {
    const { name, value } = e.target;
    setPrcStrctData((prevState) => ({ ...prevState, [name]: value }));
    onUpdate(prcStrctData.psId, name, value, {});
  };
  return (
    <>
      <tr data-testid="priceStructures">
        <td>
          <label htmlFor="pcName">Price Structure Name:</label>
        </td>
        <td>
          <table>
            <tbody>
            <thead>
              <tr style={{ display: 'none'}}>
                <th scope="col">PC Name</th>
                <th scope="col">PC Remove</th>
              </tr>
            </thead>
              <tr>
                <td style={{ border: 'none', paddingLeft: '0rem' }}>
                  <input
                    type="text"
                    name="name"
                    id="pcName"
                    className="fmc-input"
                    value={prcStrctData.name || ''}
                    onChange={handleOnChange}
                  />
                </td>
                <td style={{ border: 'none' }}>
                  <div className="fmc-check">
                    <label htmlFor="remove">
                      <input
                        type="checkbox"
                        name="remove"
                        id="remove"
                        value={prcStrctData.remove}
                        onChange={handleClearPriceStruct}
                      />
                      <span>Clear this pricing structure</span>
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td>
          <label htmlFor="selfHelpAmt">Self Help Amount:</label>
        </td>
        <td>
          <input
            type="text"
            id="selfHelpAmt"
            name="selfHelpAmt"
            className="fmc-input"
            value={prcStrctData.selfHelpAmt || ''}
            onChange={handleOnChange}
          />
        </td>
      </tr>
      <tr>
        <td>
          <label htmlFor="volFeeAmt">Voluntary Contractor Fee Amount:</label>
        </td>
        <td>
          <input
            type="text"
            id="volFeeAmt"
            name="volFeeAmt"
            className="fmc-input"
            value={prcStrctData.volFeeAmt || ''}
            onChange={handleOnChange}
          />
        </td>
      </tr>
      <tr>
        <td>
          <label htmlFor="dealerVolFeeAmt">Dealer Voluntary Contractor Fee Amount:</label>
        </td>
        <td>
          <input
            type="text"
            id="dealerVolFeeAmt"
            name="dealerVolFeeAmt"
            className="fmc-input"
            value={prcStrctData.dealerVolFeeAmt || ''}
            onChange={handleOnChange}
          />
        </td>
      </tr>
      <tr>
        <td>
          <label htmlFor="closeFeeAmt">Close Fee Amount:</label>
        </td>
        <td>
          <input
            type="text"
            name="closeFeeAmt"
            id="closeFeeAmt"
            className="fmc-input"
            value={prcStrctData.closeFeeAmt || '0'}
            onChange={handleOnChange}
          />
        </td>
      </tr>
      <tr>
        <td>
          <label htmlFor="cntngntIn">Contingency Indicator:</label>
        </td>
        <td>
          <select
            name="cntngntIn"
            id="cntngntIn"
            value={prcStrctData.cntngntIn}
            className="fmc-select"
            style={{ width: '5em' }}
            onChange={handleSelection}
          >
            <option value="C">C</option>
            <option value="N">N</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>
          <label htmlFor="dlvryToAuctIn">Delivery to Auction Indicator:</label>
        </td>
        <td>
          <select
            name="dlvryToAuctIn"
            id="dlvryToAuctIn"
            size="1"
            value={prcStrctData.dlvryToAuctIn}
            className="fmc-select"
            style={{ width: '5em' }}
            onChange={handleSelection}
          >
            <option value="D">D</option>
            <option value="N">N</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>
          <label htmlFor="gvwTypeCd">GVW Indicator:</label>
        </td>
        <td>
          <select
            name="gvwTypeCd"
            id="gvwTypeCd"
            size="1"
            value={prcStrctData.gvwTypeCd}
            className="fmc-select"
            style={{ width: '5em' }}
            onChange={handleSelection}
          >
            <option value="M">M</option>
            <option value="H">H</option>
            <option value="A">A</option>
            <option value="N">N</option>
          </select>
        </td>
      </tr>
    </>
  );
};

PriceStruct.propTypes = {
  prcStrctData: PropTypes.shape({

  }),
  onUpdate: PropTypes.func,
};

export default PriceStruct;
